export const ASSIGN_LICENSE_CONFIRM_TEXT =
  'I understand that I can\'t assign this license to a different school after I select "Assign License"'
export const TERMS_OF_SERVICE_CONFIRM_TEXT =
  'By checking this box, I agree to the terms of the'
